import { Dialog, DialogTitle, IconButton, Typography } from "@mui/material";

import { X } from "@phosphor-icons/react";

import type { Example } from "@/types";

import EditExample from "./EditExample";
import ViewExample from "./ViewExample";

interface ExampleModalProps {
  isOpen: boolean;
  index: number;
  onClose: () => void;
  example: Example | null;
  isEditing?: boolean;
  onUpdate?: (index: number, example: Example) => void;
  onCancelEdit?: () => void;
  onApprove?: () => void;
  onEdit?: () => void;
  onRegenerate?: () => void;
  onDelete?: () => void;
}

const ExampleModal = ({
  isOpen,
  onClose,
  example,
  index,
  isEditing,
  onUpdate,
  onCancelEdit,
  onApprove,
  onEdit,
  onRegenerate,
  onDelete,
}: ExampleModalProps) => {
  if (!isOpen || !example) return null;

  return (
    <Dialog
      open={isOpen}
      onClose={onClose}
      maxWidth="md"
      fullWidth
    >
      <DialogTitle
        sx={{
          px: 3,
          py: 1.5,
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <Typography variant="text14B">{`Example ${index + 1}`}</Typography>
        <IconButton
          aria-label="Close example dialog"
          onClick={onClose}
          sx={{
            position: "absolute",
            top: -24,
            right: -24,
            color: "common.white",
          }}
        >
          <X size={18} weight="bold" />
        </IconButton>
      </DialogTitle>
      {isEditing ? (
        <EditExample
          example={example}
          onUpdate={(example) => onUpdate?.(index, example)}
          onCancelEdit={() => onCancelEdit?.()}
        />
      ) : (
        <ViewExample
          example={example}
          onApprove={onApprove}
          onEdit={onEdit}
          onRegenerate={onRegenerate}
          onDelete={onDelete}
        />
      )}
    </Dialog>
  );
};

export default ExampleModal;
